module.exports = __webpack_public_path__ + "e55db98e510ffdd990487e13ab0899d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-8.png
// module id = 2239
// module chunks = 0